import { render, staticRenderFns } from "./knowledge-atlas.vue?vue&type=template&id=0912799b&scoped=true"
import script from "./knowledge-atlas.vue?vue&type=script&lang=js"
export * from "./knowledge-atlas.vue?vue&type=script&lang=js"
import style0 from "./knowledge-atlas.vue?vue&type=style&index=0&id=0912799b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0912799b",
  null
  
)

export default component.exports